<template>
    <div class="component">
        <div class="grid grid-cols-12">
            <div class="col-span-12">
                <Media :data="props.data.media[0]" />
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Array,
        default: [{
            media: {
                url: 'https://sydhavnteater:8890/assets/Screenshot-2024-07-01-at-14.12.29.jpg',
                width: 1232,
                height: 1232,
                mimeType: 'image/jpeg',
                title: 'Hero image'
            }
        }]
    }
});
</script>